import { render, staticRenderFns } from "./FilterPeople.vue?vue&type=template&id=a55ed386&"
import script from "./FilterPeople.vue?vue&type=script&lang=ts&"
export * from "./FilterPeople.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports